var _linearGradient, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.41 425.41",
    style: {
      enableBackground: "new 0 0 425.41 425.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 212.7072,
    x2: 425.4144,
    y2: 212.7072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3B96D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74CAEB"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 212.71,
    cy: 212.71,
    r: 212.71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.27,190.41h-75.81c-2.46,0-4.46-2-4.46-4.46v-75.81c0-12.31-9.98-22.3-22.3-22.3 c-12.31,0-22.3,9.98-22.3,22.3v75.81c0,2.46-2,4.46-4.46,4.46h-75.81c-12.31,0-22.3,9.98-22.3,22.3c0,12.31,9.98,22.3,22.3,22.3 h75.81c2.46,0,4.46,2,4.46,4.46v75.81c0,12.31,9.98,22.3,22.3,22.3c12.31,0,22.3-9.98,22.3-22.3v-75.81c0-2.46,2-4.46,4.46-4.46 h75.81c12.31,0,22.3-9.98,22.3-22.3C337.57,200.39,327.59,190.41,315.27,190.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.c19529f3585fa7be566b0976c17db424.svg";
export { ForwardRef as ReactComponent };